var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-view-preset"},_vm._l((_vm.colors),function(cell){return _c('div',{key:cell.id,staticClass:"widget-view-preset__cell",style:({ background: cell.color, color: _vm.getCellTextColor(cell) })},[_vm._v(" "+_vm._s(cell.id)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }